import { createSlice,PayloadAction } from "@reduxjs/toolkit"
import { startTestApi } from "../API/StartTest/startTestApi"
import {Plan as Newplans} from "../../pages/NewPricing/Plans";


interface Service {
    feature: string;
    isOffered: boolean;
    color: string;
  }
  
  interface QuestionBank {
    questionsCount: number;
    color: string;
  }
  
  interface More {
    questionBank: QuestionBank;
    duration: string;
    services: Service[];
  }
  
  interface Subscription {
    _id: string;
    name: string;
    testCount: number;
    createdDate: string; // Use Date type if you want to work with Date objects
    validityInDays: number;
    price: number;
    more: More;
    active: boolean;
  }
 interface Plan {
    pricingPlanData:Subscription[],
    selectedPlan : Newplans | null,
    selectedPaymentType : string,
 }
  
  
const initialState:Plan = {
    pricingPlanData:[],
    selectedPlan : null,
    selectedPaymentType : '',
}

const pricingPlans = createSlice({
    name: 'pricingPlans',
    initialState,
    reducers:{
        setPricing:(state,action) => {
                state.pricingPlanData = action.payload
        },
        setSelectedPlan:(state,action) => {
            state.selectedPlan = action.payload
        },
        setSelectedPaymentType:(state,action) => {
          state.selectedPaymentType = action.payload
        },
    },
    extraReducers: builder =>{
        builder.addMatcher(startTestApi.endpoints.getPricingPlansData.matchFulfilled,
            (state: Plan, action: PayloadAction<{ data: Subscription[] }>) => {
                state.pricingPlanData = action.payload?.data;
              }
        )
    }
})

export const {setPricing,setSelectedPlan,setSelectedPaymentType} = pricingPlans.actions

export default pricingPlans.reducer